import {
  FETCH_PAGE_CONTENT_SUCCESS,
  DOWNLOAD_CATEGORIES_CHECKBOX_CHANGED,
  DOWNLOAD_RADIO_CHANGED,
  RESET_DOWNLOAD_TYPE_TO_REGULAR
} from "../actions/types";
import { FETCH_DOWNLOAD_DELETE_LANDING_SUCCESS } from "../../LoggedInLanding/actions/types";
import { checkAMLob } from "utils/checkAMLob";

const initialState = {
  downloadCategories: [],
  sensitivitySelection: "REGULAR",
  formerFileFormat: "xlsx",
  fileFormat: ( checkAMLob() === "vzw" ) ? "xlsx" : "html" 
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RESET_DOWNLOAD_TYPE_TO_REGULAR:
      return {
        ...state,
        sensitivitySelection: action.payload
      };
    case DOWNLOAD_CATEGORIES_CHECKBOX_CHANGED:
      return {
        ...state,
        downloadCategories: action.payload
      };
    case DOWNLOAD_RADIO_CHANGED:
      return {
        ...state,
        [Object.keys(action.payload)[0]]: action.payload[Object.keys(action.payload)[0]]
      };
    case FETCH_PAGE_CONTENT_SUCCESS:
      if (action.payload.download_categories) {
        return {
          ...state,
          downloadCategories: action.payload.download_categories.categories
        };
      }
      return { ...state };

    case FETCH_DOWNLOAD_DELETE_LANDING_SUCCESS:
      return {
        ...state,
        sensitivitySelection: action.payload.sensitivitySelection
      };
    default:
      return state;
  }
};
